import React from "react";
import styles from "./styles.module.css";

export const Checkbox = ({ isChecked, label, theme = "dark" }) => {

  return (
    <label>
      <div className={`${styles.wrap_checkbox} ${isChecked && styles.checked} ${theme === "light" && styles.wrap_checkbox_light}`}>
        <span className={styles.label}>{label}</span>
        <span className={styles.check_mark} />
      </div>
    </label>
  );
};
